import { render, staticRenderFns } from "./MetadataEditor.vue?vue&type=template&id=264f6c70&"
import script from "./MetadataEditor.vue?vue&type=script&lang=js&"
export * from "./MetadataEditor.vue?vue&type=script&lang=js&"
import style0 from "./MetadataEditor.vue?vue&type=style&index=0&id=264f6c70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports